import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import { Dialog, DialogTitle } from '@mui/material'
import React from 'react'

interface DuplicateClientDialogProps {
    dialogOpen: boolean
    handleCloseDialog: () => void
    handleSave: () => void
    duplicates: string[]
}

const translateDuplicate = (duplicate: string) => {
    return duplicate.replace(/Name/g, "Jméno")
        .replace(/Phone/g, "Telefon")
        .replace(/CompanyRegistrationNumber/g, "IČO")
}

const DuplicateClientDialog: React.FC<DuplicateClientDialogProps> = ({ dialogOpen, handleCloseDialog, handleSave, duplicates }: DuplicateClientDialogProps) => {
    return (
        <div>
            <Dialog open={dialogOpen} onClose={handleCloseDialog}>
                <DialogTitle textAlign='center'>Klient s následujícími údaji již existuje: </DialogTitle>
                <DialogContent>
                    {
                        duplicates.map((duplicate, index) => {
                            return (
                                <DialogContentText key={index}>
                                    {translateDuplicate(duplicate)}
                                </DialogContentText>
                            )
                        })
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} autoFocus variant='contained'>
                        Zpět
                    </Button>
                    <Button onClick={() => { handleSave(); handleCloseDialog() }} >
                        Přesto uložit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default DuplicateClientDialog
